
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.531 9.062A4.536 4.536 0 0 1 0 4.532 4.537 4.537 0 0 1 4.531 0a4.539 4.539 0 0 1 4.533 4.531c0 2.5-2.035 4.531-4.533 4.531zm0-7.373A2.847 2.847 0 0 0 1.687 4.53 2.847 2.847 0 0 0 4.53 7.376 2.847 2.847 0 0 0 7.376 4.53 2.847 2.847 0 0 0 4.53 1.69zm.033 38.298a4.534 4.534 0 0 1-4.53-4.531c0-2.5 2.03-4.532 4.53-4.532a4.536 4.536 0 0 1 4.532 4.532c0 2.5-2.034 4.53-4.532 4.53zm0-7.376a2.849 2.849 0 0 0-2.844 2.845A2.847 2.847 0 0 0 4.564 38.3a2.847 2.847 0 0 0 2.843-2.844 2.847 2.847 0 0 0-2.843-2.845z"}}),_c('path',{attrs:{"d":"M4.531 10.947c-.464 0-.842-.054-.842-.12v-3.24c0-.067.378-.12.842-.12.467 0 .845.053.845.12v3.24c0 .066-.378.12-.845.12z"}}),_c('path',{attrs:{"d":"M4.531 19.213A4.536 4.536 0 0 1 0 14.683a4.537 4.537 0 0 1 4.531-4.532 4.539 4.539 0 0 1 4.533 4.531c0 2.5-2.035 4.531-4.533 4.531zm0-7.373a2.847 2.847 0 0 0-2.844 2.842 2.847 2.847 0 0 0 2.844 2.845 2.847 2.847 0 0 0 2.845-2.845A2.847 2.847 0 0 0 4.53 11.84zm0 18.04A4.536 4.536 0 0 1 0 25.349a4.537 4.537 0 0 1 4.531-4.531 4.539 4.539 0 0 1 4.533 4.53c0 2.5-2.035 4.532-4.533 4.532zm0-7.373a2.847 2.847 0 0 0-2.844 2.842 2.847 2.847 0 0 0 2.844 2.844 2.847 2.847 0 0 0 2.845-2.844 2.847 2.847 0 0 0-2.845-2.842z"}}),_c('path',{attrs:{"d":"M4.531 22.058c-.464 0-.842-.054-.842-.12v-3.24c0-.067.378-.12.842-.12.467 0 .845.053.845.12v3.24c0 .066-.378.12-.845.12zm.031 10.211c-.464 0-.842-.053-.842-.12v-3.24c0-.067.378-.12.842-.12.467 0 .845.053.845.12v3.24c0 .067-.378.12-.845.12z"}})])
          )
        }
      }
    